/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
Swiper.use([Navigation]);
export function slider() {
    const latestArchiveFilesSliderSelector = ".latest-archive-files__list-wrap.swiper";
    const customerQuotesSliderSelector = ".customer-quotes__list-wrap.swiper";
    const cardsSliderSelector = ".cards__list-wrap.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        //Archive files sliders
        const archiveFilesSliders = [];
        const archiveFilesSliderElements = document.querySelectorAll(latestArchiveFilesSliderSelector);
        if (archiveFilesSliderElements) {
            archiveFilesSliderElements.forEach(slider => {

                archiveFilesSliders.push(new Swiper(slider, {
                    speed: 500,
                    slidesPerView: "auto",
                    watchOverflow:true,
                    breakpoints: {
                        480: {
                            spaceBetween: 30,
                        },
                        1500: {
                            spaceBetween: 45
                        }
                    },
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Customer quotes sliders
        const customerQuotesSliders = [];
        const customerQuotesSliderElements = document.querySelectorAll(customerQuotesSliderSelector);
        if (customerQuotesSliderElements) {
            customerQuotesSliderElements.forEach(slider => {

                customerQuotesSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Cards sliders
        const cardsSliders = [];
        const cardsSliderElements = document.querySelectorAll(cardsSliderSelector);
        if (cardsSliderElements) {
            cardsSliderElements.forEach(slider => {

                cardsSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: "auto",
                    breakpoints: {
                        480: {
                            spaceBetween: 30,
                        },
                        1500: {
                            spaceBetween: 45,
                            slidesOffsetAfter:45
                        }
                    },
                    spaceBetween: 15,
                    slidesOffsetAfter:15,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }
    };

    init();
}
